/**
 * /places/new — direct-link manual add place. Same form as the sheet trigger
 * on /places.
 */
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/ui/PageHeader';
import { AddPlaceForm } from '../../components/AddPlaceForm';

export default function PlacesNewRoute() {
  const navigate = useNavigate();
  return (
    <>
      <PageHeader
        eyebrow="New place"
        title="Add a place."
        description="You can also capture a place by voice from the FAB."
      />
      <AddPlaceForm onCancel={() => navigate(-1)} />
    </>
  );
}
